import { render, staticRenderFns } from "./vAutocomplete.vue?vue&type=template&id=64e79060"
import script from "./vAutocomplete.vue?vue&type=script&lang=ts"
export * from "./vAutocomplete.vue?vue&type=script&lang=ts"
import style0 from "./vAutocomplete.vue?vue&type=style&index=0&id=64e79060&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports